export const Types = {
    GET_MESSAGES: "GET_MESSAGES",
    RECENT_MESSAGES: "RECENT_MESSAGES"
  };
